/* Nya sökningen, förslag A "Index" (Anders 2026-10-23).
   Facit: docs/mockup-sok/a-index.html (grenen claude/sok-mockup).
   Data: templates/collection.sokindex.liquid, sparas i sessionStorage under besöket. */
(function () {
  var el = document.querySelector('[data-sok-index]');
  if (!el) return;

  var q = el.querySelector('[data-sok-q]');
  var spok = el.querySelector('[data-sok-spok]');
  var antalEl = el.querySelector('[data-sok-antal]');
  var registerEl = el.querySelector('[data-sok-register]');
  var resultatEl = el.querySelector('[data-sok-resultat]');
  var T = el.dataset;
  var MONSTER = [];
  try {
    MONSTER = JSON.parse(el.querySelector('[data-sok-monster]').textContent).filter(Boolean);
  } catch (e) {}

  var INDEX_KEY = 'tambur-sokindex-v3';
  var data = null;
  var hamtning = null;
  var vald = -1;
  var visaAlla = false;
  var spara = null;
  var sparTimer = null;

  // ── Data ──────────────────────────────────────────────────────────────
  function hamtaIndex() {
    if (data) return Promise.resolve(data);
    if (hamtning) return hamtning;
    try {
      var cache = sessionStorage.getItem(INDEX_KEY);
      if (cache) { data = JSON.parse(cache); return Promise.resolve(data); }
    } catch (e) {}
    var bas = el.getAttribute('data-index-url');
    // En sida som inte går att läsa hoppas över i stället för att stoppa
    // sökningen, men då sparas inte indexet — nästa öppning försöker igen.
    var ofullstandig = false;
    var sida = function (n) {
      return fetch(bas + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { ofullstandig = true; return { produkter: [] }; });
    };
    hamtning = sida(1).then(function (forsta) {
      var resten = [];
      for (var n = 2; n <= (forsta.sidor || 1); n++) resten.push(sida(n));
      return Promise.all(resten).then(function (sidor) {
        var produkter = forsta.produkter.slice();
        sidor.forEach(function (s) { produkter = produkter.concat(s.produkter || []); });
        data = { produkter: produkter, kategorier: (forsta.kategorier || []).filter(function (k) { return k.t; }) };
        if (ofullstandig) { hamtning = null; return data; }
        try { sessionStorage.setItem(INDEX_KEY, JSON.stringify(data)); } catch (e) {}
        return data;
      });
    }).catch(function () { hamtning = null; return null; });
    return hamtning;
  }

  // ── Sökmotorn ─────────────────────────────────────────────────────────
  // Söker i delar av ord och i ordstammar ("lampa" → Bordslampor). Varje ord
  // i frågan måste finnas i namn, varumärke eller produkttyp.
  function lc(s) { return (s || '').toLowerCase(); }
  function stam(w) { return w.length > 4 ? w.replace(/(orna|arna|or|ar|er|a|e)$/, '') : w; }
  function ord(s) { return lc(s).trim().split(/\s+/).filter(Boolean); }
  function poang(text, orden) {
    var t = lc(text), p = 0;
    for (var i = 0; i < orden.length; i++) {
      var w = orden[i], at = t.indexOf(w);
      if (at === -1) return -1;
      if (at === 0) p += 30;
      else if (/[\s\-(|]/.test(t.charAt(at - 1))) p += 20;
      else p += 8;
      var efter = t.charAt(at + w.length);
      if (!efter || /[\s\-|)]/.test(efter)) p += 6;
    }
    return p;
  }

  function sok(fraga) {
    var orden = ord(fraga).map(stam);
    var tom = { orden: orden, produkter: [], kategorier: [], varumarken: [], monster: [], antal: 0 };
    if (!orden.length || !data) return tom;
    var traffar = [];
    data.produkter.forEach(function (p) {
      var s = poang(p.t + ' ' + p.v + ' ' + (p.y || ''), orden);
      if (s >= 0) traffar.push({ p: p, s: s + poang(p.t, orden) + (p.l ? 4 : 0) });
    });
    traffar.sort(function (a, b) { return b.s - a.s; });
    // Mönstrens kollektioner ("Nicola Fasano | Spruzzi Ambra") visas under
    // Mönster och inte en gång till bland kategorierna
    var monsterUrl = {};
    MONSTER.forEach(function (m) { monsterUrl[m.u] = 1; });
    var kategorier = data.kategorier
      .filter(function (k) { return poang(k.t, orden) >= 0 && !monsterUrl[k.u] && k.t.indexOf(' | ') === -1; })
      .sort(function (a, b) { return (ord(a.t).length - ord(b.t).length) || (b.n - a.n); })
      .slice(0, 5);
    var vm = {};
    data.produkter.forEach(function (p) { if (poang(p.v, orden) >= 0) vm[p.v] = (vm[p.v] || 0) + 1; });
    var varumarken = Object.keys(vm).map(function (v) { return { t: v, n: vm[v] }; })
      .sort(function (a, b) { return b.n - a.n; }).slice(0, 4);
    var monster = MONSTER.filter(function (m) { return poang(m.t, orden) >= 0; }).slice(0, 8);
    return { orden: orden, produkter: traffar.map(function (x) { return x.p; }), kategorier: kategorier, varumarken: varumarken, monster: monster, antal: traffar.length };
  }

  function komplettering(fraga) {
    var l = lc(fraga).replace(/^\s+/, '');
    if (l.length < 2 || !data) return '';
    var kandidater = data.kategorier.map(function (k) { return k.t; })
      .concat(MONSTER.map(function (m) { return m.t; }));
    for (var i = 0; i < kandidater.length; i++) {
      if (lc(kandidater[i]).indexOf(l) === 0 && kandidater[i].length > l.length) return kandidater[i];
    }
    return '';
  }

  // ── Utskrift ──────────────────────────────────────────────────────────
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function markera(text, orden) {
    var l = lc(text), spann = [];
    (orden || []).forEach(function (w) { var at = l.indexOf(w); if (at !== -1) spann.push([at, at + w.length]); });
    if (!spann.length) return esc(text);
    spann.sort(function (a, b) { return a[0] - b[0]; });
    var ut = '', pos = 0;
    spann.forEach(function (s) {
      if (s[0] < pos) return;
      ut += esc(text.slice(pos, s[0])) + '<mark>' + esc(text.slice(s[0], s[1])) + '</mark>';
      pos = s[1];
    });
    return ut + esc(text.slice(pos));
  }
  function pris(p) { return (p.f ? T.tFran + ' ' : '') + String(p.p).replace(/,00(?=\s)/, ''); }
  // Lagerstatus som i förslag B: webblager, annars butikens lager, annars beställningsvara
  function lagerstatus(p) {
    if (p.l) return '<span class="sok-index__lager"><i></i>' + esc(T.tILager) + '</span>';
    if (p.b) return '<span class="sok-index__lager sok-index__lager--butik"><i></i>' + esc(T.tIButik) + '</span>';
    return '<span class="sok-index__lager sok-index__lager--slut"><i></i>' + esc(T.tSlut) + '</span>';
  }
  function kort(p, i, orden) {
    return '<a class="sok-index__kort" href="' + esc(p.u) + '" data-sok-kort style="animation-delay:' + Math.min(i, 14) * 25 + 'ms">'
      + '<span class="sok-index__bild" style="background-image:url(' + esc(p.i) + ')"></span>'
      + '<span class="sok-index__namn">' + markera(p.t, orden) + '</span>'
      + '<span class="sok-index__pris">' + esc(pris(p)) + '</span>' + lagerstatus(p) + '</a>';
  }
  function lank(x, orden) {
    return '<a class="sok-index__lank" href="' + esc(x.u || ('/collections/vendors?q=' + encodeURIComponent(x.t))) + '"><span class="sok-index__txt">' + markera(x.t, orden) + '</span><sup>' + x.n + '</sup></a>';
  }

  function ritaStart() {
    antalEl.innerHTML = '';
    spok.innerHTML = '';
    registerEl.innerHTML = el.querySelector('[data-sok-start]').innerHTML;
    registerEl.classList.add('is-start');
    resultatEl.innerHTML = '<p class="sok-index__rubrik">' + esc(T.tPopulara) + '</p>'
      + el.querySelector('[data-sok-populara]').innerHTML + el.querySelector('[data-sok-nyheter]').innerHTML;
  }

  function rita() {
    var text = q.value;
    vald = -1;
    if (!text.trim()) { visaAlla = false; ritaStart(); return; }
    if (!data) {
      resultatEl.innerHTML = '<p class="sok-index__hamtar">' + esc(T.tHamtar) + '</p>';
      hamtaIndex().then(function () { if (q.value === text) rita(); });
      return;
    }
    var r = sok(text);
    var komp = komplettering(text);
    spok.innerHTML = komp ? '<span>' + esc(text) + '</span>' + esc(komp.slice(text.length)) : '';
    antalEl.innerHTML = '<b>' + r.antal + '</b> ' + esc(r.antal === 1 ? T.tTraff : T.tTraffar);

    var reg = '';
    if (r.kategorier.length) reg += '<div class="sok-index__block"><h3>' + esc(T.tKategorier) + '</h3><div class="sok-index__lankar">' + r.kategorier.map(function (k) { return lank(k, r.orden); }).join('') + '</div></div>';
    if (r.varumarken.length) reg += '<div class="sok-index__block"><h3>' + esc(T.tVarumarken) + '</h3><div class="sok-index__lankar">' + r.varumarken.map(function (v) {
      var k = data.kategorier.filter(function (c) { return lc(c.t) === lc(v.t); })[0];
      return lank({ t: v.t, n: v.n, u: k ? k.u : '/collections/vendors?q=' + encodeURIComponent(v.t) }, r.orden);
    }).join('') + '</div></div>';
    if (r.monster.length) reg += '<div class="sok-index__block"><h3>' + esc(T.tMonster) + '</h3><div class="sok-index__monster">' + r.monster.map(function (m) {
      return '<a href="' + esc(m.u) + '">' + (m.prov ? '<img src="' + esc(m.prov) + '" alt="" loading="lazy">' : '') + '<span>' + markera(m.t, r.orden) + '</span></a>';
    }).join('') + '</div></div>';
    registerEl.innerHTML = reg;
    registerEl.classList.remove('is-start');

    if (!r.antal) {
      resultatEl.innerHTML = '<div class="sok-index__inget">' + esc(T.tInga) + ' ”' + esc(text) + '”<p>' + esc(T.tIngaTips) + '</p></div>'
        + el.querySelector('[data-sok-populara]').innerHTML;
    } else {
      var visa = visaAlla ? r.produkter : r.produkter.slice(0, 15);
      resultatEl.innerHTML = '<div class="sok-index__res-topp"><span>' + esc(T.tProdukter) + '</span>'
        + (r.antal > visa.length ? '<button type="button" data-sok-visa-alla><span>' + esc(T.tVisaAlla) + ' ' + r.antal + '</span> →</button>' : '') + '</div>'
        + '<div class="sok-index__rutnat">' + visa.map(function (p, i) { return kort(p, i, r.orden); }).join('') + '</div>';
    }
    spara = { term: text.trim(), antal: r.antal };
    clearTimeout(sparTimer);
    sparTimer = setTimeout(sparaSokning, 1200);
  }

  // Sökningen rapporteras till spårningen när man slutat skriva en stund
  function sparaSokning() {
    if (!spara || !spara.term) return;
    var detalj = { search_term: spara.term, search_source: 'overlay', result_count: spara.antal };
    if (window.tamburTrackSearch) window.tamburTrackSearch(spara.term, 'overlay', { result_count: spara.antal });
    else document.dispatchEvent(new CustomEvent('tambur:tracking:search', { detail: detalj }));
  }

  function markeraKort(i) {
    var alla = el.querySelectorAll('[data-sok-kort]');
    if (!alla.length) return;
    vald = Math.max(0, Math.min(alla.length - 1, i));
    alla.forEach(function (k, j) { k.classList.toggle('is-vald', j === vald); });
    alla[vald].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function kolumner() { return window.innerWidth <= 768 ? 2 : 5; }

  // ── Öppna och stänga ──────────────────────────────────────────────────
  function sattTopp() {
    var hdr = document.querySelector('.tambur-header, header');
    var botten = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 56;
    el.style.setProperty('--sok-top', botten + 'px');
  }
  function oppna() {
    sattTopp();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sok-index-open');
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    rita();
    hamtaIndex();
    setTimeout(function () { q.focus(); }, 60);
  }
  function stang() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sok-index-open');
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    sparaSokning();
  }

  // Sidhuvudets sökknappar öppnar den nya sökningen. Klicket fångas innan den
  // gamla panelens lyssnare i header.liquid hinner reagera.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-search-open]');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (el.classList.contains('is-open')) stang(); else oppna();
  }, true);
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest('[data-search-open]')) hamtaIndex();
  }, { passive: true });

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-sok-stang]')) { stang(); return; }
    if (e.target.closest('[data-sok-visa-alla]')) { visaAlla = true; rita(); return; }
    var k = e.target.closest('[data-sok-kort]');
    if (k && spara && window.tamburMarkSearchNavigation) window.tamburMarkSearchNavigation(spara.term, 'autocomplete_click', { result_count: spara.antal });
  });
  q.addEventListener('input', function () { visaAlla = false; rita(); });
  q.addEventListener('keydown', function (e) {
    var komp = komplettering(q.value);
    if ((e.key === 'Tab' || e.key === 'ArrowRight') && komp && q.selectionStart === q.value.length) {
      e.preventDefault(); q.value = komp; rita();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault(); markeraKort(vald < 0 ? 0 : vald + kolumner());
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); if (vald >= 0) markeraKort(vald - kolumner());
    } else if (e.key === 'Enter') {
      e.preventDefault();
      var alla = el.querySelectorAll('[data-sok-kort]');
      if (vald >= 0 && alla[vald]) { alla[vald].click(); return; }
      if (q.value.trim()) { visaAlla = true; rita(); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); stang(); return; }
    if (document.activeElement === q || vald < 0) return;
    if (e.key === 'ArrowRight') markeraKort(vald + 1);
    if (e.key === 'ArrowLeft') markeraKort(vald - 1);
  });
  window.addEventListener('resize', function () { if (el.classList.contains('is-open')) sattTopp(); });
  // Mobilmenyn stänger sökningen innan den öppnas
  document.addEventListener('tambur:close-search', function () { if (el.classList.contains('is-open')) stang(); });
})();
